import { getUserTypeEffect } from '@/redux/Savers/SaversEffects';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FormSelectBox from '../Inputs/FormSelectBox';

const TrailerScsSelector = ({
  placeholder,
  label,
  rules = [],
  name,
  editMode,
  margin,
  disabled,
  onChange,
  customerKey,
  defaultValue,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const { selectedCompany } = useSelector((state) => state.auth);

  useEffect(() => {
    getUserList();
  }, [selectedCompany]);

  const getUserList = async () => {
    try {
      setLoading(true);
      const { data } = await getUserTypeEffect(customerKey);
      const options = data.map((row) => ({
        label: row.fullName,
        value: row.userId,
      }));
      setOptions(options);
      setLoading(false);
    } catch (error) {
      console.log('error', error);
      setOptions([]);
      setLoading(false);
    }
  };

  return (
    <FormSelectBox
      loading={loading}
      options={options}
      placeholder={placeholder}
      label={label}
      rules={rules}
      name={name}
      defaultValue={defaultValue}
      editMode={editMode}
      margin={margin}
      disabled={disabled}
      onChange={onChange}
    />
  );
};

export default TrailerScsSelector;
